const objectConsentSwitchReducer = (defaultValue = false, action) => {
    switch(action.type) {
        case 'SETALL_OBJECTCONSENTSWITCH':
            return action.payload;
        default:
            return defaultValue;
    }
};

export default objectConsentSwitchReducer;